<!-- Footer -->

<div class="container-fluid" id="bottom" style="background: #F16821;">

    <div class="container">

        <div class="row footer-space">
            <div class="col-md-12">
                <h1 class="footer-title">CONNECT WITH US</h1>

            </div>
        </div>

        <div class="row">

            <div class="col-md-5">

                <div class="example-container">
                    <input type="text" name="name" placeholder="Name" [(ngModel)]="name" class="footer-input"><br>
                    <input type="email" name="name" placeholder="Email" [(ngModel)]="email" class="footer-input"><br>
                    <input type="text" name="name" placeholder="Subject" [(ngModel)]="subject" class="footer-input"><br>
                    <input type="textarea" name="name" placeholder="Message" [(ngModel)]="message" class="footer-input textarea"><br>
                </div>

                <button class="btn btn-sm send-btn" (click)="send()">
                    Send &nbsp;»
                    </button>


                <div class="email">
                    <br>
                    <br>
                    <h3>OR EMAIL US AT</h3>
                    <p><img src="assets/images/Shape.png"> &nbsp; <a href="mailto:giri@evolvtax.com" style="color: white">info@evolvtax.com</a></p>
                    <!-- href="mailto:giri@evolvtax.com" -->
                </div>
            </div>


            <div class="col-md-4">
                <h4 class="location"> <img src="assets/images/Group 1087.png"> Our Locations </h4>
                <br>
                <span class="US-address">UNITED STATES OF AMERICA<br>
                    Evolv Tax LLC <br>
                    300 E. Royal Lane<br>
                    Suite 175 Irving,<br>
                    Tx 75038</span>


                <div class="number"><img src="assets/images/phone-footer.png">
                    <a href="tel:+1(737)317-2121" style="color: white"> +1 (737) 317-2121</a>
                </div>
                <div class="number"><img src="assets/images/phone-footer.png">
                    <a href="tel:+1(737)477-3047" style="color: white"> +1 (737) 477-3047</a>
                </div>
                <div class="number"><img src="assets/images/phone-footer.png">
                    <a href="tel:+1(737)327-4241" style="color: white"> +1 (737) 327-4241</a>
                </div>
                





                <br>
                <br>
                <div class="fb-icon">
                    <a href="https://www.facebook.com/evolvtax" target="_blank">
                        <img src="assets/images/facebook.png" class="fb-icon-hover"></a>
                </div>

                <!-- <div class="linkd-icon">
                    <a href="https://linkedin.com/company/evolvtax" target="_blank"><img src="assets/images/linkedin.png" class="linkd-icon-hover"></a>
                </div> -->

                <div class="fb-icon">
                    <a href="https://linkedin.com/company/evolvtax" target="_blank">
                        <img src="assets/images/linkedin.png" class="fb-icon-hover"></a>
                </div>

                <!-- <div class="fb-icon">
                    <a href="https://wa.me/12056490801?text=I'm%20interested%20to%20connect%20%20with%20you" target="_blank">
                        <img src="assets/images/Whattsapp.svg" class="fb-icon-hover"></a>
                </div> -->
            </div>

            <div class="col-md-3" style="margin-top: 50px;">

                <span class="US-address">GLOBAL DELIVERY OFFICE <br>
                    501, RVS Homes Opp. Kings<br>
                    drive-in, Hi-tech City,<br>
                    Hyderabad, Telangana<br>
                    500081
                </span>

                <!-- <div class="number"><img src="assets/images/phone-footer.png">
                    <a href="tel:9908408490" style="color: white"> +91 99084 08490</a> </div> -->

            </div>

        </div>

        <!-- Copyright -->

        <div class="row">
            <div class="col-md-12 text-center">
                <h1 class="copyright">Copyright © EvolvTax Services Pvt Ltd. All rights reserved</h1>
                <br>
            </div>
        </div>

    </div>
</div>